const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const parseDate = (dateStr: string) => {
  const parts = dateStr.split("-")
  return {
    year: parts[0],
    month: months[parseInt(parts[1], 10) - 1],
    day: parseInt(parts[2], 10),
  }
}

/**
 * Formats an event's date range for display.
 * Falls back to the legacy single `date` field when no startDate is present.
 */
export const formatEventDate = (
  startDate?: string,
  endDate?: string,
  fallbackDate?: string
) => {
  const start = startDate || fallbackDate
  if (!start) return ""

  const startParsed = parseDate(start)

  // Single day event (no end date or same as start date)
  if (!endDate || start === endDate) {
    return `${startParsed.day} ${startParsed.month}, ${startParsed.year}`
  }

  const endParsed = parseDate(endDate)

  // Same month and year: "25-27 December, 2025"
  if (
    startParsed.month === endParsed.month &&
    startParsed.year === endParsed.year
  ) {
    return `${startParsed.day}-${endParsed.day} ${startParsed.month}, ${startParsed.year}`
  }

  // Same year, different months: "30 November - 2 December, 2025"
  if (startParsed.year === endParsed.year) {
    return `${startParsed.day} ${startParsed.month} - ${endParsed.day} ${endParsed.month}, ${startParsed.year}`
  }

  // Different years: "30 December 2025 - 2 January 2026"
  return `${startParsed.day} ${startParsed.month} ${startParsed.year} - ${endParsed.day} ${endParsed.month} ${endParsed.year}`
}

/**
 * Builds a compact monogram from an event/couple name, e.g. "Amelia & Theo" -> "A & T".
 */
export const eventMonogram = (name?: string) => {
  if (!name) return ""
  const stop = ["and", "the", "of", "with", "&"]
  const words = name
    .replace(/&/g, " ")
    .split(/\s+/)
    .filter((w) => w && !stop.includes(w.toLowerCase()))
  const letters = words.map((w) => w[0]?.toUpperCase()).filter(Boolean)
  if (letters.length === 0) return name.slice(0, 1).toUpperCase()
  return letters.slice(0, 2).join(" & ")
}
